/**
 * @generated SignedSource<<c8db6aa2102ea5807368ad3698463f8e>>
 * @relayHash 69fb974715421103f4460b382b90a6b1
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 45051c26a591137186ac37b5b5203b14e7ffd598b387eb741f38827bc152f4a6

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type L1MenuItemsQuery$variables = {
  cloudId: string;
  entityAriApps: string;
  entityAriFilters: string;
  entityAriPlans: string;
  isAnonymous: boolean;
  isAppsExpanded?: boolean | null;
  isFiltersExpanded?: boolean | null;
  isOperationsExpanded?: boolean | null;
  isPlansExpanded?: boolean | null;
  isProjectsExpanded?: boolean | null;
  isRoadmapUpsellEnabled: boolean;
  ownerAri?: string | null;
};
export type L1MenuItemsQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"ConfigurableMenuItems">;
};
export type L1MenuItemsQuery = {
  response: L1MenuItemsQuery$data;
  variables: L1MenuItemsQuery$variables;
};
({
  "__relay_internal__pv__atlassianjirarelayprovidersrcjiracustomtemplateallowenduserstocreatecustomtemplatesrelayprovider": isAllowingEndUsersToAccessCustomTemplates_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcatlasprojectnativeintegrationm2relayprovider": isSubspaceEnabled_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcjsmaiiyfornavitemsidebarrelayprovider": checkForA11YEnabledFF_provider
} as {
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcatlasprojectnativeintegrationm2relayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcjiracustomtemplateallowenduserstocreatecustomtemplatesrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcjsmaiiyfornavitemsidebarrelayprovider: {
    readonly get: () => boolean;
  };
});

import isSubspaceEnabled_provider from '@atlassian/jira-relay-provider/src/atlas-project-native-integration-m2.relayprovider';
import isAllowingEndUsersToAccessCustomTemplates_provider from '@atlassian/jira-relay-provider/src/jira-custom-template-allow-end-users-to-create-custom-templates.relayprovider';
import checkForA11YEnabledFF_provider from '@atlassian/jira-relay-provider/src/jsm-aiiy-for-nav-item-sidebar.relayprovider';

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "entityAriApps"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "entityAriFilters"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "entityAriPlans"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isAnonymous"
},
v5 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "isAppsExpanded"
},
v6 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "isFiltersExpanded"
},
v7 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "isOperationsExpanded"
},
v8 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "isPlansExpanded"
},
v9 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "isProjectsExpanded"
},
v10 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isRoadmapUpsellEnabled"
},
v11 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "ownerAri"
},
v12 = {
  "kind": "ScalarField",
  "name": "menuId"
},
v13 = {
  "kind": "ScalarField",
  "name": "id"
},
v14 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
},
v15 = [
  (v14/*: any*/)
],
v16 = {
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "hasNextPage"
    }
  ]
},
v17 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v18 = {
  "kind": "ScalarField",
  "name": "label"
},
v19 = {
  "kind": "ScalarField",
  "name": "styleClass"
},
v20 = {
  "kind": "ScalarField",
  "name": "url"
},
v21 = {
  "order": "DESC"
},
v22 = {
  "kind": "Literal",
  "name": "first",
  "value": 15
},
v23 = {
  "kind": "ScalarField",
  "name": "title"
},
v24 = {
  "kind": "ScalarField",
  "name": "isFavourite"
},
v25 = {
  "concreteType": "JiraFavouriteValue",
  "kind": "LinkedField",
  "name": "favouriteValue",
  "plural": false,
  "selections": [
    (v24/*: any*/),
    (v13/*: any*/)
  ]
},
v26 = {
  "kind": "InlineFragment",
  "selections": [
    (v13/*: any*/)
  ],
  "type": "Node",
  "abstractKey": "__isNode"
},
v27 = [
  {
    "kind": "LinkedField",
    "name": "node",
    "plural": false,
    "selections": [
      (v17/*: any*/),
      {
        "kind": "InlineFragment",
        "selections": [
          (v13/*: any*/),
          {
            "kind": "ScalarField",
            "name": "collectionId"
          },
          (v23/*: any*/),
          {
            "kind": "ScalarField",
            "name": "emoji"
          },
          (v25/*: any*/)
        ],
        "type": "JiraProductDiscoveryCollection"
      },
      (v26/*: any*/)
    ]
  }
],
v28 = {
  "kind": "ClientExtension",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "__id"
    }
  ]
},
v29 = {
  "kind": "Literal",
  "name": "first",
  "value": 20
},
v30 = {
  "alias": "projectKey",
  "kind": "ScalarField",
  "name": "key"
},
v31 = {
  "kind": "ScalarField",
  "name": "status"
},
v32 = {
  "kind": "ScalarField",
  "name": "projectType"
},
v33 = {
  "concreteType": "JiraAvatar",
  "kind": "LinkedField",
  "name": "avatar",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "large"
    }
  ]
},
v34 = {
  "kind": "ScalarField",
  "name": "name"
},
v35 = {
  "kind": "ScalarField",
  "name": "projectId"
},
v36 = [
  (v20/*: any*/)
],
v37 = {
  "kind": "LinkedField",
  "name": "defaultNavigationItem",
  "plural": false,
  "selections": [
    (v17/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": (v36/*: any*/),
      "type": "JiraNavigationItem",
      "abstractKey": "__isJiraNavigationItem"
    },
    (v26/*: any*/)
  ]
},
v38 = {
  "args": [
    {
      "kind": "Literal",
      "name": "type",
      "value": "EDIT_PROJECT_CONFIG"
    }
  ],
  "concreteType": "JiraProjectAction",
  "kind": "LinkedField",
  "name": "action",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "canPerform"
    }
  ],
  "storageKey": "action(type:\"EDIT_PROJECT_CONFIG\")"
},
v39 = {
  "kind": "ScalarField",
  "name": "projectStyle"
},
v40 = {
  "kind": "ScalarField",
  "name": "softwareBoardCount"
},
v41 = {
  "kind": "ScalarField",
  "name": "webUrl"
},
v42 = {
  "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcatlasprojectnativeintegrationm2relayprovider",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "kind": "ClientExtension",
      "selections": [
        {
          "alias": "subspaceCount",
          "kind": "ScalarField",
          "name": "subspaceCount_cse"
        }
      ]
    }
  ]
},
v43 = [
  (v13/*: any*/),
  (v30/*: any*/),
  (v31/*: any*/),
  (v32/*: any*/),
  (v33/*: any*/),
  (v34/*: any*/),
  (v35/*: any*/),
  (v24/*: any*/),
  (v37/*: any*/),
  (v38/*: any*/),
  (v39/*: any*/),
  (v40/*: any*/),
  (v41/*: any*/),
  (v42/*: any*/)
],
v44 = {
  "concreteType": "JiraProjectEdge",
  "kind": "LinkedField",
  "name": "edges",
  "plural": true,
  "selections": [
    {
      "concreteType": "JiraProject",
      "kind": "LinkedField",
      "name": "node",
      "plural": false,
      "selections": (v43/*: any*/)
    }
  ]
},
v45 = {
  "kind": "ScalarField",
  "name": "filterId"
},
v46 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "isEditable"
    },
    {
      "kind": "LinkedField",
      "name": "owner",
      "plural": false,
      "selections": [
        (v17/*: any*/),
        {
          "kind": "ScalarField",
          "name": "accountId"
        },
        (v13/*: any*/)
      ]
    }
  ],
  "type": "JiraCustomFilter"
},
v47 = {
  "kind": "Variable",
  "name": "ownerAri",
  "variableName": "ownerAri"
},
v48 = [
  {
    "concreteType": "SettingsMenuItemConnection",
    "kind": "LinkedField",
    "name": "sidebar",
    "plural": false,
    "selections": [
      {
        "concreteType": "SettingsMenuItem",
        "kind": "LinkedField",
        "name": "nodes",
        "plural": true,
        "selections": [
          (v12/*: any*/),
          {
            "kind": "ScalarField",
            "name": "visible"
          }
        ]
      }
    ]
  },
  (v13/*: any*/)
],
v49 = [
  {
    "kind": "LinkedField",
    "name": "node",
    "plural": false,
    "selections": [
      (v17/*: any*/),
      {
        "kind": "InlineFragment",
        "selections": [
          (v13/*: any*/),
          {
            "kind": "ScalarField",
            "name": "planId"
          },
          (v23/*: any*/),
          {
            "kind": "ScalarField",
            "name": "isReadOnly"
          },
          {
            "kind": "ScalarField",
            "name": "planStatus"
          },
          (v25/*: any*/),
          {
            "concreteType": "JiraScenario",
            "kind": "LinkedField",
            "name": "scenario",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "scenarioId"
              },
              (v13/*: any*/)
            ]
          },
          {
            "kind": "LinkedField",
            "name": "defaultNavigationItem",
            "plural": false,
            "selections": [
              (v17/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": (v36/*: any*/),
                "type": "JiraSoftwareBuiltInNavigationItem"
              },
              (v26/*: any*/)
            ]
          }
        ],
        "type": "JiraPlan"
      },
      (v26/*: any*/)
    ]
  }
],
v50 = [
  (v13/*: any*/),
  (v34/*: any*/),
  {
    "kind": "ScalarField",
    "name": "alertSearchQuery"
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/),
      (v10/*: any*/),
      (v11/*: any*/)
    ],
    "kind": "Fragment",
    "name": "L1MenuItemsQuery",
    "selections": [
      {
        "condition": "isAnonymous",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "ConfigurableMenuItems"
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/),
      (v7/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v11/*: any*/),
      (v4/*: any*/),
      (v10/*: any*/),
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiracustomtemplateallowenduserstocreatecustomtemplatesrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcatlasprojectnativeintegrationm2relayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjsmaiiyfornavitemsidebarrelayprovider"
      }
    ],
    "kind": "Operation",
    "name": "L1MenuItemsQuery",
    "selections": [
      {
        "condition": "isAnonymous",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "concreteType": "JiraQuery",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
              {
                "args": [
                  {
                    "kind": "Variable",
                    "name": "cloudID",
                    "variableName": "cloudId"
                  },
                  {
                    "kind": "Literal",
                    "name": "navKey",
                    "value": "NAV_SIDEBAR"
                  }
                ],
                "concreteType": "JiraUserNavigationConfiguration",
                "kind": "LinkedField",
                "name": "userNavigationConfiguration",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "JiraConfigurableNavigationItem",
                    "kind": "LinkedField",
                    "name": "navItems",
                    "plural": true,
                    "selections": [
                      (v12/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "isVisible"
                      }
                    ]
                  },
                  (v13/*: any*/)
                ]
              }
            ]
          },
          {
            "concreteType": "JiraQuery",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
              {
                "condition": "isProjectsExpanded",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "alias": "hasIsProjectsExpanded",
                    "kind": "ScalarField",
                    "name": "__typename"
                  }
                ]
              },
              {
                "alias": "canCreateProject",
                "args": [
                  (v14/*: any*/),
                  {
                    "kind": "Literal",
                    "name": "type",
                    "value": "CREATE_PROJECT"
                  }
                ],
                "kind": "ScalarField",
                "name": "canPerform"
              },
              {
                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiracustomtemplateallowenduserstocreatecustomtemplatesrelayprovider",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "alias": "shouldDisplay",
                    "args": [
                      (v14/*: any*/),
                      {
                        "kind": "Literal",
                        "name": "type",
                        "value": "VIEW_PROJECT_CREATION_ENTRY"
                      }
                    ],
                    "kind": "ScalarField",
                    "name": "canPerform"
                  }
                ]
              },
              {
                "condition": "isFiltersExpanded",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "alias": "hasIsFiltersExpanded",
                    "kind": "ScalarField",
                    "name": "__typename"
                  }
                ]
              },
              {
                "condition": "isAppsExpanded",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "args": (v15/*: any*/),
                    "concreteType": "JiraNavigationItemConnection",
                    "kind": "LinkedField",
                    "name": "globalAppNavigationItems",
                    "plural": false,
                    "selections": [
                      (v16/*: any*/),
                      {
                        "concreteType": "JiraNavigationItemEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v17/*: any*/),
                              (v13/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v18/*: any*/),
                                  {
                                    "kind": "ScalarField",
                                    "name": "appId"
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "name": "appType"
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "name": "envLabel"
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "name": "iconUrl"
                                  },
                                  (v19/*: any*/),
                                  {
                                    "concreteType": "JiraAppSection",
                                    "kind": "LinkedField",
                                    "name": "sections",
                                    "plural": true,
                                    "selections": [
                                      (v18/*: any*/),
                                      {
                                        "concreteType": "JiraAppNavigationItemNestedLink",
                                        "kind": "LinkedField",
                                        "name": "links",
                                        "plural": true,
                                        "selections": [
                                          (v18/*: any*/),
                                          (v20/*: any*/),
                                          (v19/*: any*/)
                                        ]
                                      }
                                    ]
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "name": "settingsUrl"
                                  },
                                  (v20/*: any*/)
                                ],
                                "type": "JiraAppNavigationItem"
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              },
              {
                "alias": "roadmapFavourites",
                "args": [
                  (v14/*: any*/),
                  {
                    "kind": "Literal",
                    "name": "filter",
                    "value": {
                      "sort": (v21/*: any*/),
                      "type": "JPD_COLLECTION"
                    }
                  },
                  (v22/*: any*/)
                ],
                "concreteType": "JiraFavouriteConnection",
                "kind": "LinkedField",
                "name": "favourites",
                "plural": false,
                "selections": [
                  (v16/*: any*/),
                  {
                    "concreteType": "JiraFavouriteEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": (v27/*: any*/)
                  },
                  (v28/*: any*/)
                ]
              },
              {
                "alias": "roadmapRecents",
                "args": [
                  (v14/*: any*/),
                  (v29/*: any*/),
                  {
                    "kind": "Literal",
                    "name": "types",
                    "value": [
                      "JPD_COLLECTION"
                    ]
                  }
                ],
                "concreteType": "JiraSearchableEntityConnection",
                "kind": "LinkedField",
                "name": "recentItems",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "JiraSearchableEntityEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": (v27/*: any*/)
                  },
                  (v28/*: any*/)
                ]
              }
            ]
          },
          {
            "concreteType": "JiraQuery",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
              {
                "condition": "isPlansExpanded",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "alias": "hasIsPlansExpanded",
                    "kind": "ScalarField",
                    "name": "__typename"
                  }
                ]
              },
              {
                "args": (v15/*: any*/),
                "concreteType": "JiraAdvancedRoadmapsNavigation",
                "kind": "LinkedField",
                "name": "advancedRoadmapsNavigation",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "hasEditPermissions"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "hasCreateSamplePlanPermissions"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "hasGlobalPlansAdminPermissions"
                  }
                ]
              }
            ]
          },
          {
            "condition": "isProjectsExpanded",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "concreteType": "JiraQuery",
                "kind": "LinkedField",
                "name": "jira",
                "plural": false,
                "selections": [
                  {
                    "args": (v15/*: any*/),
                    "concreteType": "JiraWorkManagementLicensing",
                    "kind": "LinkedField",
                    "name": "jwmLicensing",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "currentUserSeatEdition"
                      }
                    ]
                  }
                ]
              },
              {
                "args": (v15/*: any*/),
                "concreteType": "JiraProjectsSidebarMenu",
                "kind": "LinkedField",
                "name": "jira_projectsSidebarMenu",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "JiraProject",
                    "kind": "LinkedField",
                    "name": "mostRecent",
                    "plural": false,
                    "selections": (v43/*: any*/)
                  },
                  {
                    "concreteType": "JiraProject",
                    "kind": "LinkedField",
                    "name": "mostRecentFromHistory",
                    "plural": false,
                    "selections": [
                      (v13/*: any*/),
                      (v30/*: any*/),
                      (v24/*: any*/),
                      (v31/*: any*/),
                      (v32/*: any*/),
                      (v33/*: any*/),
                      (v34/*: any*/),
                      (v35/*: any*/),
                      (v37/*: any*/),
                      (v38/*: any*/),
                      (v39/*: any*/),
                      (v40/*: any*/),
                      (v41/*: any*/),
                      (v42/*: any*/)
                    ]
                  },
                  {
                    "args": [
                      (v22/*: any*/)
                    ],
                    "concreteType": "JiraProjectConnection",
                    "kind": "LinkedField",
                    "name": "favourites",
                    "plural": false,
                    "selections": [
                      (v16/*: any*/),
                      (v44/*: any*/),
                      (v28/*: any*/)
                    ],
                    "storageKey": "favourites(first:15)"
                  },
                  {
                    "args": [
                      (v29/*: any*/)
                    ],
                    "concreteType": "JiraProjectConnection",
                    "kind": "LinkedField",
                    "name": "recents",
                    "plural": false,
                    "selections": [
                      (v44/*: any*/),
                      (v28/*: any*/)
                    ],
                    "storageKey": "recents(first:20)"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "favouriteLimit"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "recentLimit"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "displayMode"
                  },
                  (v13/*: any*/)
                ]
              }
            ]
          },
          {
            "condition": "isFiltersExpanded",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "concreteType": "JiraQuery",
                "kind": "LinkedField",
                "name": "jira",
                "plural": false,
                "selections": [
                  {
                    "alias": "favouriteFilters",
                    "args": [
                      (v14/*: any*/),
                      {
                        "kind": "Literal",
                        "name": "filter",
                        "value": {
                          "sort": (v21/*: any*/),
                          "type": "FILTER"
                        }
                      },
                      (v22/*: any*/)
                    ],
                    "concreteType": "JiraFavouriteConnection",
                    "kind": "LinkedField",
                    "name": "favourites",
                    "plural": false,
                    "selections": [
                      (v16/*: any*/),
                      {
                        "concreteType": "JiraFavouriteEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v17/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v13/*: any*/),
                                  (v45/*: any*/),
                                  (v34/*: any*/),
                                  (v24/*: any*/),
                                  (v46/*: any*/)
                                ],
                                "type": "JiraFilter",
                                "abstractKey": "__isJiraFilter"
                              },
                              (v26/*: any*/)
                            ]
                          }
                        ]
                      },
                      (v28/*: any*/)
                    ]
                  },
                  {
                    "alias": "recentFilters",
                    "args": [
                      (v14/*: any*/),
                      (v29/*: any*/),
                      {
                        "kind": "Literal",
                        "name": "types",
                        "value": [
                          "FILTER"
                        ]
                      }
                    ],
                    "concreteType": "JiraSearchableEntityConnection",
                    "kind": "LinkedField",
                    "name": "recentItems",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "JiraSearchableEntityEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v17/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v45/*: any*/),
                                  (v13/*: any*/),
                                  (v34/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v24/*: any*/),
                                      (v46/*: any*/)
                                    ],
                                    "type": "JiraFilter",
                                    "abstractKey": "__isJiraFilter"
                                  }
                                ],
                                "type": "JiraCustomFilter"
                              },
                              (v26/*: any*/)
                            ]
                          }
                        ]
                      },
                      (v28/*: any*/)
                    ]
                  },
                  {
                    "args": (v15/*: any*/),
                    "concreteType": "JiraSystemFilterConnection",
                    "kind": "LinkedField",
                    "name": "systemFilters",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "JiraSystemFilterEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "concreteType": "JiraSystemFilter",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v13/*: any*/),
                              (v45/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v34/*: any*/),
                                  (v17/*: any*/),
                                  (v24/*: any*/),
                                  (v46/*: any*/)
                                ],
                                "type": "JiraFilter",
                                "abstractKey": "__isJiraFilter"
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              },
              {
                "alias": "filtersOrder",
                "args": [
                  {
                    "kind": "Variable",
                    "name": "entityAri",
                    "variableName": "entityAriFilters"
                  },
                  (v47/*: any*/)
                ],
                "concreteType": "SettingsNavigationCustomisation",
                "kind": "LinkedField",
                "name": "settings_navigationCustomisation",
                "plural": false,
                "selections": (v48/*: any*/)
              }
            ]
          },
          {
            "condition": "isPlansExpanded",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "concreteType": "JiraQuery",
                "kind": "LinkedField",
                "name": "jira",
                "plural": false,
                "selections": [
                  {
                    "alias": "favouritePlans",
                    "args": [
                      (v14/*: any*/),
                      {
                        "kind": "Literal",
                        "name": "filter",
                        "value": {
                          "sort": (v21/*: any*/),
                          "type": "PLAN"
                        }
                      },
                      (v22/*: any*/)
                    ],
                    "concreteType": "JiraFavouriteConnection",
                    "kind": "LinkedField",
                    "name": "favourites",
                    "plural": false,
                    "selections": [
                      (v16/*: any*/),
                      {
                        "concreteType": "JiraFavouriteEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": (v49/*: any*/)
                      },
                      (v28/*: any*/)
                    ]
                  },
                  {
                    "alias": "recentPlans",
                    "args": [
                      (v14/*: any*/),
                      (v29/*: any*/),
                      {
                        "kind": "Literal",
                        "name": "types",
                        "value": [
                          "PLAN"
                        ]
                      }
                    ],
                    "concreteType": "JiraSearchableEntityConnection",
                    "kind": "LinkedField",
                    "name": "recentItems",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "JiraSearchableEntityEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": (v49/*: any*/)
                      },
                      (v28/*: any*/)
                    ]
                  }
                ]
              },
              {
                "alias": "plansOrder",
                "args": [
                  {
                    "kind": "Variable",
                    "name": "entityAri",
                    "variableName": "entityAriPlans"
                  },
                  (v47/*: any*/)
                ],
                "concreteType": "SettingsNavigationCustomisation",
                "kind": "LinkedField",
                "name": "settings_navigationCustomisation",
                "plural": false,
                "selections": (v48/*: any*/)
              }
            ]
          },
          {
            "condition": "isAppsExpanded",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": "appsOrder",
                "args": [
                  {
                    "kind": "Variable",
                    "name": "entityAri",
                    "variableName": "entityAriApps"
                  },
                  (v47/*: any*/)
                ],
                "concreteType": "SettingsNavigationCustomisation",
                "kind": "LinkedField",
                "name": "settings_navigationCustomisation",
                "plural": false,
                "selections": (v48/*: any*/)
              }
            ]
          },
          {
            "condition": "isOperationsExpanded",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "concreteType": "OpsgenieQuery",
                "kind": "LinkedField",
                "name": "opsgenie",
                "plural": false,
                "selections": [
                  {
                    "args": (v15/*: any*/),
                    "concreteType": "OpsgenieSavedSearches",
                    "kind": "LinkedField",
                    "name": "savedSearches",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "OpsgenieSavedSearch",
                        "kind": "LinkedField",
                        "name": "starred",
                        "plural": true,
                        "selections": (v50/*: any*/)
                      },
                      {
                        "concreteType": "OpsgenieSavedSearch",
                        "kind": "LinkedField",
                        "name": "sharedWithMe",
                        "plural": true,
                        "selections": (v50/*: any*/)
                      },
                      {
                        "concreteType": "OpsgenieSavedSearch",
                        "kind": "LinkedField",
                        "name": "createdByMe",
                        "plural": true,
                        "selections": (v50/*: any*/)
                      }
                    ]
                  }
                ]
              }
            ]
          },
          {
            "condition": "isRoadmapUpsellEnabled",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "concreteType": "JiraQuery",
                "kind": "LinkedField",
                "name": "jira",
                "plural": false,
                "selections": [
                  {
                    "args": [
                      {
                        "kind": "Variable",
                        "name": "accountId",
                        "variableName": "ownerAri"
                      },
                      (v14/*: any*/),
                      {
                        "kind": "Literal",
                        "name": "propertyKey",
                        "value": "jpd-roadmaps-upsell.dismissed"
                      }
                    ],
                    "concreteType": "JiraEntityPropertyString",
                    "kind": "LinkedField",
                    "name": "stringUserProperty",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "stringValue"
                      },
                      (v13/*: any*/)
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "45051c26a591137186ac37b5b5203b14e7ffd598b387eb741f38827bc152f4a6",
    "metadata": {},
    "name": "L1MenuItemsQuery",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__atlassianjirarelayprovidersrcjiracustomtemplateallowenduserstocreatecustomtemplatesrelayprovider": isAllowingEndUsersToAccessCustomTemplates_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcatlasprojectnativeintegrationm2relayprovider": isSubspaceEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjsmaiiyfornavitemsidebarrelayprovider": checkForA11YEnabledFF_provider
    }
  }
};
})();

(node as any).hash = "81003b54ce89d01024f55a09499a220e";

export default node;
